// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import { BASENAME } from './envVariables';

const History = createBrowserHistory({ basename: `${BASENAME}` });

export default History;
